module.exports = __webpack_public_path__ + "img/for-all-budgets.9ac0031.svg";